export enum Points {
  school = 'school',
  POI = 'POI',
  distributionPoint = 'distribution-point',
  beatBox = 'beatbox',
  gem = 'gem',
}
